  class BreweriesSlider extends HTMLElement {
    constructor(){
      super();
      const breakpoint = window.matchMedia( '(min-width:750px)' );
      let mySwiper; 
      const breakpointChecker = function() {
        // if larger viewport and multi-row layout needed
        if ( breakpoint.matches === true ) {
          // clean up old instances and inline styles when available
          if ( mySwiper !== undefined ) mySwiper.destroy( true, true );
          // or/and do nothing
          return;
          // else if a small viewport and single column layout needed
          } else if ( breakpoint.matches === false ) {
            // fire small viewport version of swiper
            return enableSwiper();
          }
      };
      const enableSwiper = function() {
        mySwiper = new Swiper ('.swiper-container-breweries', {
          loop: true,
          // pagination
          slidesPerView: 1.01,
          pagination: '.swiper-pagination-breweries',
          paginationClickable: true,
        });
      }; 
      breakpoint.addListener(breakpointChecker);
      // kickstart
      breakpointChecker();
    }
  }
  customElements.define("breweries-slider", BreweriesSlider);